import BrTag from "./BrTag";
import FontTag from "./FontTag";
import HeadingTag from "./HeadingTag";
import IdentityTag from "./IdentityTag";
import LineTag from "./LineTag";
import LinkTag from "./LinkTag";
import MoreTag from "./MoreTag";
import SizeTag from "./SizeTag";
import SpoilerTag from "./SpoilerTag";
import StyleTag from "./StyleTag";
import SvgTag from "./SvgTag";
import TooltipTag from "./TooltipTag";
import YoutubeTag from "./YoutubeTag";
import * as bbcode from "bbcode-to-react";
const fullParser = new bbcode.Parser();
fullParser.registerTag("size", SizeTag);
fullParser.registerTag("br", BrTag);
fullParser.registerTag("email", LinkTag);
fullParser.registerTag("link", LinkTag);
fullParser.registerTag("url", LinkTag);
fullParser.registerTag("spoiler", SpoilerTag);
fullParser.registerTag("font", FontTag);
fullParser.registerTag("youtube", YoutubeTag);
fullParser.registerTag("line", LineTag);
fullParser.registerTag("heading", HeadingTag);
fullParser.registerTag("svg", SvgTag);
fullParser.registerTag("more", MoreTag);
fullParser.registerTag("tooltip", TooltipTag);
fullParser.registerTag("style", StyleTag);
const stripParser = new bbcode.Parser();
stripParser.registerTag("br", BrTag);
[
    "size",
    "email",
    "font",
    "link",
    "url",
    "spoiler",
    "font",
    "youtube",
    "line",
    "heading",
    "svg",
    "b",
    "u",
    "style",
].forEach((tag) => stripParser.registerTag(tag, IdentityTag));
let convertDiv;
function transformSymbol(fullMatch, symbol) {
    if (convertDiv === undefined) {
        convertDiv = document.createElement("div");
    }
    convertDiv.innerHTML = symbol;
    return convertDiv.innerText;
}
export function preProcess(input) {
    return input
        .replace(/<br *\/?>/g, "[br][/br]")
        .replace(/(&[^;]+;)/g, transformSymbol);
}
function renderBBCode(input, context) {
    if (input === undefined) {
        return [""];
    }
    if (context !== undefined) {
        return fullParser["renderer"].context(context, () => fullParser.toReact(preProcess(input)));
    }
    else {
        return fullParser.toReact(preProcess(input));
    }
}
export function stripBBCode(input) {
    if (input === undefined) {
        return "";
    }
    return stripParser
        .toReact(input
        .replace(/<br *\/?>/g, "[br][/br]")
        .replace(/(&[^;]+;)/g, transformSymbol))
        .filter((line) => typeof line === "string")
        .join("");
}
export function bbcodeToHTML(input) {
    const res = fullParser.toHTML(preProcess(input));
    // according to the typings toHTML should return an array of strings but
    // in practice I found it to return just a string
    if (Array.isArray(res)) {
        return res.join();
    }
    else {
        return res;
    }
}
export default renderBBCode;
